import { FieldNamesMarkedBoolean, UseFormRegister } from 'react-hook-form'
import { Prompts } from '../../api/apiHooks'
import { EditedBadge } from '../EditedBadge'
import { CrossIcon, EditIcon } from '../icons'

interface DescriptionSectionProps {
  isEditingDescription: boolean
  setIsEditingDescription: (
    value: boolean | ((prev: boolean) => boolean),
  ) => void
  selectedPrompt?: Prompts
  register: UseFormRegister<Prompts>
  dirtyFields?: Partial<
    Readonly<FieldNamesMarkedBoolean<Omit<Prompts, 'response_format'>>>
  >
}

export const DescriptionSection = ({
  isEditingDescription,
  setIsEditingDescription,
  selectedPrompt,
  register,
  dirtyFields,
}: DescriptionSectionProps) => (
  <div className="flex items-center gap-2 mb-4">
    {isEditingDescription ? (
      <input
        {...register('description')}
        type="text"
        className="w-full px-3 py-1 tc-mv-question-field text-white rounded-2xl outline-none"
        placeholder="Enter description..."
        autoFocus
      />
    ) : (
      <p className="text-gray-400 flex-1 flex items-center">
        {selectedPrompt?.description || 'No description available'}
        <EditedBadge isEdited={dirtyFields?.description} />
      </p>
    )}
    <button
      type="button"
      onClick={() => setIsEditingDescription(prev => !prev)}
      className="flex-shrink-0 p-1 text-gray-400 hover:text-white transition-colors"
      title="Edit description"
    >
      {!isEditingDescription ? <EditIcon /> : <CrossIcon />}
    </button>
  </div>
)
